import React from 'react'
import { Link } from 'react-router-dom'
import PageMeta from '../components/PageMeta'
import { COMPANY_INFO } from '../data/pagesData'

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] bg-slate-50 flex items-center justify-center py-16 px-4">
      <PageMeta title="404 - Siden blev ikke fundet | Sakskær Auto" description="Siden du leder efter findes desværre ikke hos Sakskær Auto." />
      
      <div className="max-w-md w-full bg-white p-8 rounded-2xl border border-slate-200 shadow-sm text-center space-y-6">
        <div className="w-16 h-16 rounded-full bg-red-100 text-red-700 flex items-center justify-center mx-auto text-2xl font-black">
          404
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-slate-900">Siden blev ikke fundet</h1>
          <p className="text-sm text-slate-600 leading-relaxed">
            Beklager, den side du leder efter eksisterer ikke eller er blevet flyttet.
          </p>
        </div>

        <div className="pt-2 space-y-3">
          <Link
            to="/"
            className="w-full inline-flex items-center justify-center gap-2 bg-red-700 hover:bg-red-800 text-white font-semibold py-3 px-6 rounded-md transition-colors shadow-xs text-sm cursor-pointer"
          >
            <i className="fa-solid fa-house" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            className="w-full inline-flex items-center justify-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold py-2.5 px-6 rounded-md transition-colors text-xs cursor-pointer whitespace-nowrap"
          >
            <i className="fa-solid fa-phone" aria-hidden="true" />
            <span>Kontakt os på {COMPANY_INFO.phone}</span>
          </a>
        </div>
      </div>
    </div>
  )
}
